const API_KEY = "bdffd76d95da4a6ab8ac10d44f8d6a3f";
const ACCESS_TOKEN = "YOUR_ACCESS_TOKEN";
const BASE_URL = "https://stock.adobe.io/Rest/Media/1/Search/Files";
const APP_URL = "https://images.okepas.com";
const galleryContainer = document.getElementById("galleryContainer");
const paginationContainer = document.getElementById("pagination-controls");
const loader = document.querySelector(".loading-images");
const itemsPerPage = 18;
let currentPage = 1;
let totalItems = 0;
let filteredImages = [];
const limitPerPage = 10;

document.addEventListener("DOMContentLoaded", async () => {
  const customerId = ShopifyAnalytics.meta?.page?.customerId;
  fetchMostLoved(currentPage);
  if (customerId) {
    const favBtn = document.getElementById("favBtn");
    if (favBtn) {
      favBtn.style.display = "block";
    }
  }
});

document.getElementById("searchBtn").addEventListener("click", function () {
  const query = document.getElementById("searchInput").value.trim();
  if (!query) {
    alert("Please enter a search term.");
    return;
  }

  loader.style.display = "block";
  currentPage = 1;
  const finalQuery = `${query}`;

  fetchImages(finalQuery);
});

galleryContainer.addEventListener("click", async function (event) {
  if (event.target && event.target.matches(".add-button")) {
    const dataId = event.target.getAttribute("data-id");
    try {
      const button = event.target;
      const loader = button.nextElementSibling;
      loader.style.display = "block";
      const response = await fetch(`https://images.okepas.com/download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ assetId: dataId }),
      });

      if (!response.ok) {
        loader.style.display = "none";
        throw new Error(
          `Failed to send data to the API. Status: ${response.status}`
        );
      }

      const data = await response.json();

      if (data.status) {
        loader.style.display = "none";

        const countryMap = {
          CA: "ca",
          EU: "eu",
          AT: "eu",
          AU: "au",
        };

        const currencyMap = {
          CA: "CAD", // Canadian Dollar
          EU: "EUR", // Euro
          AT: "EUR", // Austria is in the EU, uses Euro
          AU: "AUD", // Australian Dollar
        };

        let country = countryMap[Shopify.country] || "eu";

        let currency = currencyMap[Shopify.country] || "EUR";

        const url = `https://okepas.com/en-${country}/products/okepas-custom-sneaker?pattern=${data.filePath}&local=en-${country}&currency=${currency}`;
        // window.open(url);
        window.location.href = url;
      }

      if (!data.status) {
        loader.style.display = "none";
        alert(data.message);
      }
    } catch (error) {
      loader.style.display = "none";
      console.error("Error:", error);
    }
  }

  if (event.target && event.target.matches(".wishlist-icon")) {
    const icon = event.target;
    const assetId = icon.getAttribute("data-id");
    const isCustomerLoggedIn = ShopifyAnalytics.meta?.page?.customerId;
    const imageContainer = icon.closest(".gallery-item");
    const imageElement = imageContainer.querySelector("img");
    const imageSrc = imageElement?.getAttribute("src");
    if (isCustomerLoggedIn) {
      icon.classList.toggle("active");
      icon.textContent = icon.classList.contains("active") ? "❤️" : "🤍";
      if (icon.classList.contains("active")) {
        addToWishlist(assetId, imageSrc, isCustomerLoggedIn);
      } else {
        removeFromWishlist(assetId, isCustomerLoggedIn);
      }
    } else {
      icon.classList.toggle("active");
      icon.textContent = icon.classList.contains("active") ? "❤️" : "🤍";
      if (icon.classList.contains("active")) {
        setWishlistToCookies(assetId, imageSrc);
      } else {
        removeFromWishlistCookies(assetId);
      }
    }
  }
});

function fetchImages(query = null) {
  $("#pagination-controls").css("display", "none");
  $("#pagination").css("display", "block");
  let queryParams = `?search_parameters[filters][content_type:photo]=1`;
  queryParams += `&search_parameters[filters][use]=commercial`;
  queryParams += `&search_parameters[filters][orientation]=horizontal`;
  queryParams += `&search_parameters[limit]=${itemsPerPage}`;
  queryParams += `&search_parameters[offset]=${
    (currentPage - 1) * itemsPerPage
  }`;

  if (query) {
    queryParams += `&search_parameters[words]=${encodeURIComponent(
      query
    )} pattern`;
  } else {
    // queryParams += `&search_parameters[words]= graffiti pattern`;
    // $("#searchInput").val("graffiti");
  }

  const url = `${BASE_URL}${queryParams}`;

  const loader = document.querySelector(".loading-images");
  loader.style.display = "block";

  fetch(url, {
    method: "GET",
    headers: {
      "X-Api-Key": API_KEY,
      "X-Product": "Your_Product_Identifier",
      Accept: "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      return response.json();
    })
    .then((data) => {
      loader.style.display = "none";

      totalItems = data.nb_results || 0;
      const filteredImages = data.files || [];

      populateGallery(filteredImages);
      updatePagination();
    })
    .catch((error) => {
      loader.style.display = "none";
      console.error("Error fetching images:", error);
    });
}

async function populateGallery(images) {
  const isCustomerLoggedIn = ShopifyAnalytics.meta?.page?.customerId;
  let favouriteImageIds = [];
  let discardedImageIds = [];
  var discardedResult = await getDiscarded();
  console.log({discardedResult});
  discardedImageIds = discardedResult.data.map((discarded) => discarded.image_id);
  if (isCustomerLoggedIn) {
    favouriteImageIds = await getFavourites(isCustomerLoggedIn);
    favouriteImageIds = favouriteImageIds.data.map((fav) => fav.image_id);
  } else {
    const wishlist = await getWishlistFromCookies();
    favouriteImageIds = wishlist.map((fav) => fav.image_id);
  }
  galleryContainer.innerHTML = "";

  if (images.length === 0) {
    galleryContainer.innerHTML =
      "<p>No images found. Try another search term.</p>";
    return;
  }

  images.forEach((image) => {
    const isFavourite = favouriteImageIds.includes(String(image.id));
    const isDiscarded = discardedImageIds.includes(String(image.id));
    if(!isDiscarded){
      const imgElement = document.createElement("span");
      imgElement.className = "gallery-item image-container";
      imgElement.innerHTML = `<div class="wishlist-icon ${
        isFavourite ? "active" : ""
      }" data-id="${image.id}">${isFavourite ? "❤️" : "🤍"}</div>
      <img src="${image.thumbnail_url}" alt="${image.title}" />
      <button class="add-button" data-id="${image.id}">Add</button>
      <div class="loader" style="display: none;"></div>
    `;
    galleryContainer.appendChild(imgElement);
    }
    
  });
}

async function getFavourites(customerId) {
  try {
    const response = await fetch(
      `${APP_URL}/api/favourites?user_id=${customerId}`
    );
    if (!response.ok) throw new Error("Failed to fetch favourites");

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching favourites:", error);
    return [];
  }
}

async function getDiscarded() {
  try {
    const response = await fetch(
      `${APP_URL}/api/discarded`
    );
    if (!response.ok) throw new Error("Failed to fetch discarded");

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching discarded:", error);
    return [];
  }
}

function updatePagination() {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const paginationContainer = document.getElementById("pagination");
  paginationContainer.innerHTML = "";

  // Create Previous button
  const prevButton = document.createElement("button");
  prevButton.textContent = "Previous";
  prevButton.disabled = currentPage === 1;
  prevButton.addEventListener("click", function () {
    if (currentPage > 1) {
      currentPage--;
      fetchImages(document.getElementById("searchInput").value.trim());
    }
  });
  paginationContainer.appendChild(prevButton);

  const pageLimit = 7;
  const ellipsis = document.createElement("span");
  ellipsis.textContent = "...";

  if (totalPages <= pageLimit) {
    for (let i = 1; i <= totalPages; i++) {
      createPageButton(i, paginationContainer);
    }
  } else {
    createPageButton(1, paginationContainer);

    if (currentPage > 4) {
      paginationContainer.appendChild(ellipsis);
    }

    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);

    for (let i = startPage; i <= endPage; i++) {
      createPageButton(i, paginationContainer);
    }

    if (currentPage < totalPages - 3) {
      paginationContainer.appendChild(ellipsis);
    }

    createPageButton(totalPages, paginationContainer);
  }

  const nextButton = document.createElement("button");
  nextButton.textContent = "Next";
  nextButton.disabled = currentPage === totalPages;
  nextButton.addEventListener("click", function () {
    if (currentPage < totalPages) {
      currentPage++;
      fetchImages(document.getElementById("searchInput").value.trim());
    }
  });
  paginationContainer.appendChild(nextButton);
}

function createPageButton(pageNumber, container) {
  const pageButton = document.createElement("button");
  pageButton.textContent = pageNumber;
  pageButton.className = pageNumber === currentPage ? "active" : "";
  pageButton.addEventListener("click", function () {
    currentPage = pageNumber;
    fetchImages(document.getElementById("searchInput").value.trim());
  });
  container.appendChild(pageButton);
}

document.getElementById("prevPage").addEventListener("click", function () {
  if (currentPage > 1) {
    currentPage--;
    fetchImages(document.getElementById("searchInput").value.trim());
  }
});

document.getElementById("nextPage").addEventListener("click", function () {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  if (currentPage < totalPages) {
    currentPage++;
    fetchImages(document.getElementById("searchInput").value.trim());
  }
});

const urlParams = new URLSearchParams(window.location.search);
const searchParam = urlParams.get("search"); // Get 'search' parameter from URL

if (searchParam) {
  document.getElementById("searchInput").value = searchParam;
  const finalQuery = `${searchParam}`;

  fetchImages(finalQuery);
}

// fetchImages();

function addToWishlist(assetId, imageSrc, customerId) {
  if (customerId) {
    const icon = document.querySelector(`.wishlist-icon[data-id="${assetId}"]`);
    const span = icon.closest("span");
    const perImageLoader = span.querySelector(".loader");
    perImageLoader.style.display = "block";
    const url = `${APP_URL}/api/favourites/add`;
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        image_id: assetId,
        image_src: imageSrc,
        user_id: customerId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const countEl = document.getElementById("wishlist-count");
        if (countEl && data.count !== undefined) {
          countEl.textContent = data.count;
        }
      })
      .catch((error) => {
        console.error("Error adding to wishlist:", error);
      })
      .finally(() => {
        perImageLoader.style.display = "none";
      });
  }
}

function removeFromWishlist(assetId, customerId) {
  const icon = document.querySelector(`.wishlist-icon[data-id="${assetId}"]`);
  const span = icon.closest("span");
  const perImageLoader = span.querySelector(".loader");
  perImageLoader.style.display = "block";
  const url = `${APP_URL}/api/favourites/delete/${assetId}?user_id=${customerId}`;
  fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => {
      const countEl = document.getElementById("wishlist-count");
      if (countEl && data.count !== undefined) {
        countEl.textContent = data.count;
      }
    })
    .catch((error) => {
      console.error("Error adding to wishlist:", error);
    })
    .finally(() => {
      perImageLoader.style.display = "none";
    });
}

async function fetchMostLoved(page = 1) {
  const isCustomerLoggedIn = ShopifyAnalytics.meta?.page?.customerId;
  let favouriteImageIds = [];

  if (isCustomerLoggedIn) {
    favouriteImageIds = await getFavourites(isCustomerLoggedIn);
    favouriteImageIds = favouriteImageIds.data.map((fav) => fav.image_id);
  } else {
    const wishlist = await getWishlistFromCookies();
    favouriteImageIds = wishlist.map((fav) => fav.image_id);
  }
  loader.style.display = "block";
  galleryContainer.innerHTML = "";
  $("#searchInput").val("");
  $("#pagination-controls").css("display", "block");
  $("#pagination").css("display", "none");
  try {
    const response = await fetch(
      `${APP_URL}/api/most-loved?page=${page}&limit=${limitPerPage}`
    );
    const result = await response.json();
    const images = result.data;
    const pagination = result.pagination;

    loader.style.display = "none";

    if (!images || images.length === 0) {
      galleryContainer.innerHTML = "<p>No images found.</p>";
      return;
    }

    images.forEach((fav) => {
      const imgElement = document.createElement("span");
      imgElement.className = "gallery-item image-container";
      const isFavourite = favouriteImageIds.includes(String(fav.image_id));
      imgElement.innerHTML = `<div class="wishlist-icon ${
        isFavourite ? "active" : ""
      }" data-id="${fav.image_id}">${isFavourite ? "❤️" : "🤍"}</div>
          <img src="${fav.image_src}" alt="Favourite image" />
          <button class="add-button" data-id="${fav.image_id}">Add</button>
          <div class="loader" style="display: none;"></div>
        `;
      galleryContainer.appendChild(imgElement);
    });

    renderPaginationControls(pagination);
  } catch (error) {
    loader.style.display = "none";
    console.error("Failed to load images:", error);
    galleryContainer.innerHTML = "<p>Error loading images.</p>";
  }
}

function renderPaginationControls(pagination) {
  paginationContainer.innerHTML = "";

  for (let i = 1; i <= pagination.totalPages; i++) {
    const button = document.createElement("button");
    button.textContent = i;
    button.className = i === pagination.page ? "active-page" : "";
    button.addEventListener("click", () => {
      currentPage = i;
      fetchMostLoved(currentPage);
    });
    paginationContainer.appendChild(button);
  }
}

function removeFromWishlistCookies(assetId) {
  const wishlist = getWishlistFromCookies().filter(
    (item) => item.image_id !== assetId
  );
  document.cookie = `wishlist=${encodeURIComponent(
    JSON.stringify(wishlist)
  )}; path=/; max-age=${60 * 60 * 24 * 30}`;
  const countEl = document.getElementById("wishlist-count");
  if (countEl) {
    countEl.textContent = wishlist.length;
  }
}

function getWishlistFromCookies() {
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("wishlist="));
  if (!cookie) return [];
  try {
    return JSON.parse(decodeURIComponent(cookie.split("=")[1]));
  } catch (e) {
    console.error("Invalid wishlist cookie:", e);
    return [];
  }
}

function setWishlistToCookies(assetId, imageSrc) {
  const wishlist = getWishlistFromCookies();
  const alreadyExists = wishlist.some((item) => item.image_id === assetId);
  if (!alreadyExists) {
    wishlist.push({ image_id: assetId, image_src: imageSrc });
    document.cookie = `wishlist=${encodeURIComponent(
      JSON.stringify(wishlist)
    )}; path=/; max-age=${60 * 60 * 24 * 30}`;
    const countEl = document.getElementById("wishlist-count");
    if (countEl) {
      countEl.textContent = wishlist.length;
    }
  }
}
